//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uiBottom from '@/component/uiBottom'
import { controlTopButton } from '@/util/const'

export default {
  components: {
    uiBottom
  },
  data () {
    return {}
  },
  created () {
    controlTopButton({
      backVisible: false,
    })
  },
  methods: {
    jump () {
      location.href = 'cmcchkh5action://close'
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/concert/applySuccess.vue